"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTableActions = exports.EntityTableActionsComponent = exports.EntityTableActionsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_button_1 = require("../elements/icon-button");
var use_lang_1 = require("../../hooks/use-lang");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var current_user_can_1 = require("../../utils/current-user-can");
exports.EntityTableActionsDefaultProps = {
  editLabel: 'Edit',
  deleteLabel: 'Delete',
  removeLabel: 'Remove'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EditButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var RemoveButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var DeleteButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var ButtonItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n  "], ["\n    margin: 0;\n    padding: 0;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 24px;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n    ", ";\n    background-position: top right;\n    padding-right: ", ";\n    margin-right: ", ";\n    &:last-child {\n      background: none;\n      border-right: none;\n      margin-right: none;\n    }\n  "], ["\n    height: 24px;\n    display: flex;\n    font-size: ", ";\n    align-items: center;\n    ", ";\n    background-position: top right;\n    padding-right: ", ";\n    margin-right: ", ";\n    &:last-child {\n      background: none;\n      border-right: none;\n      margin-right: none;\n    }\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.DOT_BG('v', 'line-mid', 2, 5), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n    margin-right: ", ";\n    &:last-child {\n      border-right: none;\n      margin-right: none;\n    }\n  "], ["\n    padding-right: ", ";\n    margin-right: ", ";\n    &:last-child {\n      border-right: none;\n      margin-right: none;\n    }\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5))
});
var ButtonItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    justify-content: space-between;\n  "], ["\n    list-style: none;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    justify-content: space-between;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    justify-content: flex-start;\n  "], ["\n    justify-content: flex-start;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ButtonItems: styled_components_1.default.ul(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ButtonItemsStyles),
  ButtonItem: styled_components_1.default.li(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ButtonItemStyles),
  EditButton: (0, styled_components_1.default)(icon_button_1.UpdateIconButton)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), EditButtonStyles),
  RemoveButton: (0, styled_components_1.default)(icon_button_1.DeleteIconButton)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), RemoveButtonStyles),
  DeleteButton: (0, styled_components_1.default)(icon_button_1.DeleteIconButton)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), DeleteButtonStyles)
};
var EntityTableActionsComponent = function (props) {
  var className = props.className,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    onRemove = props.onRemove,
    editLabel = props.editLabel,
    deleteLabel = props.deleteLabel,
    removeLabel = props.removeLabel,
    entityTypeName = props.entityTypeName;
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  if (!defn) {
    return null;
  }
  var user = (0, use_active_person_1.useActivePerson)();
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.ButtonItems, null, onEdit && ((0, current_user_can_1.personCanUpdate)(user, defn.scopeSlug) || (0, current_user_can_1.personCanCreate)(user, defn.scopeSlug)) && react_1.default.createElement(My.ButtonItem, null, react_1.default.createElement(My.EditButton, {
    onClick: onEdit
  }, t(editLabel))), onDelete && ((0, current_user_can_1.personCanDelete)(user, defn.scopeSlug) || (0, current_user_can_1.personCanCreate)(user, defn.scopeSlug)) && react_1.default.createElement(My.ButtonItem, null, react_1.default.createElement(My.DeleteButton, {
    onClick: onEdit
  }, t(deleteLabel))), onRemove && ((0, current_user_can_1.personCanDelete)(user, defn.scopeSlug) || (0, current_user_can_1.personCanCreate)(user, defn.scopeSlug)) && react_1.default.createElement(My.ButtonItem, null, react_1.default.createElement(My.RemoveButton, {
    onClick: onRemove
  }, t(removeLabel)))));
};
exports.EntityTableActionsComponent = EntityTableActionsComponent;
exports.EntityTableActionsComponent.defaultProps = exports.EntityTableActionsDefaultProps;
exports.EntityTableActions = react_1.default.memo(exports.EntityTableActionsComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;